import React, { useState, useEffect } from 'react';
import LearnMoreContent from './LearnMoreContent';  // Import LearnMoreContent

const WelcomeTooltip = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showLearnMore, setShowLearnMore] = useState(false);  // Track Learn More state

  useEffect(() => {
    const hasVisited = document.cookie.split(';').some((item) => item.trim().startsWith('visited='));

    if (!hasVisited) {
      setIsVisible(true); // Show tooltip if no cookie
    }
  }, []);

  const handleCloseTooltip = () => {
    setIsVisible(false);
    document.cookie = "visited=true; max-age=31536000; path=/"; // 1 year
  };

  const handleLearnMore = () => {
    setShowLearnMore(true);  // Show Learn More popup
    handleCloseTooltip();    // Close the Welcome tooltip
  };

  const handleCloseLearnMore = () => {
    setShowLearnMore(false);  // Close Learn More popup
  };

  return (
    <>
      {isVisible && (
        <div style={tooltipStyles.overlay}>
          <div style={tooltipStyles.tooltipWelcome}>
            <p>Welcome to DrugsPRO. This app provides information about drugs for harm reduction. Find substances by typing in the search field. If you have reagent tests you can click the vial icon to search by reaction colors.</p>
            <button onClick={handleLearnMore} style={tooltipStyles.buttonLearn}>Learn more</button>
            <button onClick={handleCloseTooltip} style={tooltipStyles.buttonOk}>OK</button>
          </div>
        </div>
      )}

      {showLearnMore && (
        <div style={tooltipStyles.overlay}>  {/* Modal popup for LearnMoreContent */}
          <div style={tooltipStyles.tooltip}>  {/* Using the same tooltip styles for the modal */}
            <LearnMoreContent onClose={handleCloseLearnMore} />  {/* Display Learn More content inside modal */}
          </div>
        </div>
      )}
    </>
  );
};

const tooltipStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  tooltipWelcome: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    margin: '20px',
    maxWidth: '600px',
    width: '80%',
    textAlign: 'center',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    overflowY: 'auto',
    maxHeight: '90vh',
  },
  tooltip: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    margin: '20px',
    maxWidth: '600px',
    width: '80%',
    textAlign: 'left',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    overflowY: 'auto',
    maxHeight: '90vh',
  },
  buttonLearn: {
    marginTop: '10px',
    marginRight: '10px',
    padding: '10px 20px',
    border: 'none',
    backgroundColor: '#a4a4a4',
    color: 'white',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  buttonOk: {
    marginTop: '10px',
    padding: '10px 20px',
    border: 'none',
    backgroundColor: '#dcaa2e',
    color: 'white',
    borderRadius: '5px',
    cursor: 'pointer',
  },
};

export default WelcomeTooltip;
